import { AgentManagement } from "@/components/AgentManagement";
import { useNavigate } from "react-router-dom";

export const AgentsPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <AgentManagement onBack={handleBack} />;
};
